var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'mobile' : _vm.isMobile}, _vm.activePanel, _vm._.toLower(_vm.$route.name)],attrs:{"id":"app"}},[(_vm.ready)?_vm._t("default",[_c('Header'),_c('div',{staticClass:"inc"},[_c('router-view')],1),_c('Footer')]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }